import { useQuery } from "@tanstack/react-query";
import { useAuth } from "zudoku/hooks";
import { useTenantStore } from "../stores/tenantStore";

export default function useGetApiLogs() {
  const apiAccessUrl = import.meta.env.ZUDOKU_PUBLIC_APIACCESSMANAGEMENT_FA_URL;
  const subscriptionKey = import.meta.env.ZUDOKU_PUBLIC_SUBSCRIPTION_KEY;

  const {providerData} = useAuth();
  const token = providerData?.accessToken || providerData?.idToken;


  const tenantCode = useTenantStore((state) => state.currentTenant);

  return useQuery({
    retry: false,
    enabled: !!tenantCode && !!token,
    queryKey: ['GET', tenantCode, `${apiAccessUrl}/apiAuditLogEntries`],
    queryFn: async () => {
      const response = await fetch(`${apiAccessUrl}/apiAuditLogEntries`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "Authorization": `Bearer ${token}`,
          "X-NBLY-Tenant-Code": tenantCode,
          "X-NBLY-Portal-Type": 'participant',
          "Ocp-Apim-Subscription-Key": subscriptionKey,
      },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch Api AuditLogEntries');
      }
      const data = await response.json();
      return data;
    },
  });
}